import { Injectable, NgModule } from '@angular/core';
import { DataApiService, BaseService } from '@xpo-ltl/data-api';
import { ConfigManagerService, CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@xpo-ltl/data-api';
import * as ɵngcc2 from '@xpo-ltl/config-manager';
class GeoLocationApiService extends BaseService {
    /**
     * @param {?} dataApiService
     * @param {?} configManager
     */
    constructor(dataApiService, configManager) {
        super();
        this.dataApiService = dataApiService;
        this.configManager = configManager;
    }
    /**
     * Health check URL. Responds with success message if the service is running.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    healthCheck(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/health-check'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List of resources.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    options(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/options'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Details of user invoking the API.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    loggedInUser(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/appusers/logged-in-user'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * For XPO customer use. Returns a list of Geo Postal codes for a given city, State/Province and country.
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listGeoPostalCodesByCity(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/geopostalcodes'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * For XPO customer use. Returns city, state, and country for the postal code provided.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getGeoCityStateCountryByPostalCode(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/geo-city-state-country/{postalCd}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * @return {?}
     */
    getEndPoint() {
        return this.configManager.getSetting(GeoLocationApiService.GeoLocationApiEndpoint);
    }
}
GeoLocationApiService.ɵfac = function GeoLocationApiService_Factory(t) { return new (t || GeoLocationApiService)(ɵngcc0.ɵɵinject(ɵngcc1.DataApiService), ɵngcc0.ɵɵinject(ɵngcc2.ConfigManagerService)); };
GeoLocationApiService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: GeoLocationApiService, factory: GeoLocationApiService.ɵfac });
GeoLocationApiService.GeoLocationApiEndpoint = 'geolocationApiEndpoint';
/** @nocollapse */
GeoLocationApiService.ctorParameters = () => [
    { type: DataApiService },
    { type: ConfigManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GeoLocationApiService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.DataApiService }, { type: ɵngcc2.ConfigManagerService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const ɵ0 = { configFileUrl: './assets/config.json' };
class SdkGeoLocationModule {
}
SdkGeoLocationModule.ɵfac = function SdkGeoLocationModule_Factory(t) { return new (t || SdkGeoLocationModule)(); };
SdkGeoLocationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SdkGeoLocationModule });
SdkGeoLocationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        GeoLocationApiService,
        { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
    ], imports: [[
            ConfigManagerModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SdkGeoLocationModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ConfigManagerModule
                ],
                providers: [
                    GeoLocationApiService,
                    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SdkGeoLocationModule, { imports: function () { return [ConfigManagerModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * GeoLocation API
 * Version: 1.0
 * Build: Manual
 */
/**
 * Request message to get the Postal Code for an input city
 */
class ListGeoPostalCodesByCityRqst {
    constructor() {
        /**
         * City Name part of the address.
         * Required: true
         * Array: false
         */
        this.cityName = undefined;
        /**
         * Standard Postal abbreviation for state name. Example: OR for Oregon.
         * Required: true
         * Array: false
         */
        this.stateCd = undefined;
        /**
         * standard Postal abbreviation for a country. Example: CA for Canada.
         * Required: true
         * Array: false
         */
        this.countryCd = undefined;
    }
}
/**
 * Response message
 */
class ListGeoPostalCodesByCityResp {
    constructor() {
        /**
         * Required: false
         * Array: true
         */
        this.geoLocation = undefined;
    }
}
/**
 * Request message to return the city, state, and country for the postal code provided.
 */
class GetGeoCityStateCountryByPostalCdRqst {
    constructor() {
        /**
         * The postal code for which the city, state, and country will be returned.
         * Required: true
         * Array: false
         */
        this.postalCd = undefined;
    }
}
/**
 * Response to the request to return the city, state, and country for the postal code provided.
 */
class GetGeoCityStateCountryByPostalCdResp {
    constructor() {
        /**
         * Basic geolocation information.
         * Required: false
         * Array: true
         */
        this.geoLocation = undefined;
    }
}
/**
 * Query parameters for listGeoPostalCodesByCity
 */
class ListGeoPostalCodesByCityQuery {
    constructor() {
        this.cityName = undefined;
        this.stateCd = undefined;
        this.countryCd = undefined;
    }
}
/**
 * Path parameters for getGeoCityStateCountryByPostalCode
 */
class GetGeoCityStateCountryByPostalCodePath {
    constructor() {
        this.postalCd = undefined;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { SdkGeoLocationModule, GeoLocationApiService, ListGeoPostalCodesByCityRqst, ListGeoPostalCodesByCityResp, GetGeoCityStateCountryByPostalCdRqst, GetGeoCityStateCountryByPostalCdResp, ListGeoPostalCodesByCityQuery, GetGeoCityStateCountryByPostalCodePath };

